import { CompanyPrimaryContact } from "../../users/user";

export interface ILoggedUser {
  title: string;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  telephone: string;
  mobile: string;
  fax: string;
  jobTitle: string;
  address1: string;
  address2: string;
  town: string;
  county: string;
  postcode: string;
  displayWelcomeFlag: boolean;
  forcePasswordChange: boolean;
  grants: string[];
  id: string;
  companyId: string;
  role: string;
  companyPrimaryContact: CompanyPrimaryContact;
  allowOrderNotes: boolean;
  allowAlternateDeliveryAddress: boolean;
  applications_access: string[];
}


export class LoggedUser {
  title: string;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  telephone: string;
  mobile: string;
  fax: string;
  jobTitle: string;
  address1: string;
  address2: string;
  town: string;
  county: string;
  postcode: string;
  displayWelcomeFlag: boolean;
  forcePasswordChange: boolean;
  grants: string[];
  id: string;
  companyId: string;
  role: string;
  companyPrimaryContact: CompanyPrimaryContact;
  allowOrderNotes: boolean;
  allowAlternateDeliveryAddress: boolean;
  applications_access: string[];
}

export class LoggedUserModel {
  EndPointURL: string;
  Token: string;
  UserId: string;
}


export class TokenModel {
  access_token: string;
  token_type: string;
  expires_in: number;
  userName: string;
  userId: string;
  companyId: string;
  allowOrderNotes: boolean;
  allowAlternateDeliveryAddress: boolean;
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/loggeduser/loggeduser.ts